import request from '@/utils/requestAuth'

const userApi = {
  Login: '/auth/login',
  Logout: '/auth/logout',
  ForgePassword: '/auth/forge-password',
  Register: '/auth/register',
  twoStepCode: '/auth/2step-code',
  SendSms: '/account/sms',
  SendSmsErr: '/account/sms_err',
  // get my info
  UserInfo: '/user/info',
  UserMenu: '/user/nav',
  rsaGen: '/auth/v1/rsa_gen', //加密字段
  loginBy: '/auth/user_login/pwd/v1', //账号密码登录
  loginPhone: '/auth/user_login/send_code/verify/v1', //手机号验证码登录
  existPhone: '/auth/user_login/account/is_exited/v1', //验证手机号是否存在
  sendCode: '/auth/user_login/send_code/v1', //获取手机验证码
  // configRole:'/auth/role_mangement/config/v1', //获取角色管理配置
  configRole:'/common/config/v1', //获取角色管理配置
  createPwd:'/auth/user_login/pwd/create/v1', //创建密码
  isVaild:'/auth/user_login/account_is_vaild/v1', //手机号码是否被禁用
}

/**
 * login func
 * parameter: {
 *     username: '',
 *     password: '',
 *     remember_me: true,
 *     captcha: '12345'
 * }
 * @param parameter
 * @returns {*}
 */
export function login (parameter) {
  return request({
    url: userApi.Login,
    method: 'post',
    data: parameter
  })
}

//加密字段
export function rsaGen (parameter) {
  return request({
    url: userApi.rsaGen,
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

//账号密码登录
export function loginBy (parameter) {
  return request({
    url: userApi.loginBy,
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

//手机号验证码登录
export function loginPhone (parameter) {
  return request({
    url: userApi.loginPhone,
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

//验证手机号是否存在
export function existPhone (parameter) {
  return request({
    url: userApi.existPhone,
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

//创建密码
export function createPwd (parameter) {
  return request({
    url: userApi.createPwd,
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

//手机号码是否被禁用
export function isVaild(parameter) {
  return request({
    url: userApi.isVaild,
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

//获取手机验证码
export function sendCode (parameter) {
  return request({
    url: userApi.sendCode,
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

//获取用户权限
export function configRole (parameter) {
  return request({
    url: userApi.configRole,
    method: 'get',
    params: parameter
  })
}

export function getSmsCaptcha (parameter) {
  return request({
    url: userApi.SendSms,
    method: 'post',
    data: parameter
  })
}

export function getInfo () {
  return request({
    url: userApi.UserInfo,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function getCurrentUserNav () {
  return request({
    url: userApi.UserMenu,
    method: 'get'
  })
}

export function logout () {
  return request({
    url: userApi.Logout,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

/**
 * get user 2step code open?
 * @param parameter {*}
 */
export function get2step (parameter) {
  return request({
    url: userApi.twoStepCode,
    method: 'post',
    data: parameter
  })
}
